export class UserSearch {
  constructor (userSearchCriteria) {
    this.id = userSearchCriteria ? userSearchCriteria.id : null
    this.login = userSearchCriteria ? userSearchCriteria.login : null
    this.lastName = userSearchCriteria ? userSearchCriteria.lastName : null
    this.firstName = userSearchCriteria ? userSearchCriteria.firstName : null
    this.group = userSearchCriteria ? userSearchCriteria.group : null
    this.beginDate = userSearchCriteria ? userSearchCriteria.beginDate : null
    this.endDate = userSearchCriteria ? userSearchCriteria.endDate : null
    this.entrepriseId = userSearchCriteria ? userSearchCriteria.entrepriseId : null
    this.entity = userSearchCriteria ? userSearchCriteria.entity : null
    this.siret = userSearchCriteria ? userSearchCriteria.siret : null
    this.status = userSearchCriteria ? userSearchCriteria.status : null
    this.excludeSelectedStatus = userSearchCriteria ? userSearchCriteria.excludeSelectedStatus : false
    this.creationSort = userSearchCriteria ? userSearchCriteria.creationSort : null
    this.connexionSort = userSearchCriteria ? userSearchCriteria.connexionSort : null
    this.beginIndex = userSearchCriteria ? userSearchCriteria.beginIndex : null
    this.endIndex = userSearchCriteria ? userSearchCriteria.endIndex : null
  }
}
